import * as React from 'react';
import Spacing from '@able/react/dist/Spacing';
import {ProgressTrackerSection} from './components/progress-tracker-section';
import {ProductSheetProgressTracker} from '@applications/order-tracker/config/order-tracker-new-common/constants';
import ProgressTrackerTabFooter from './components/progress-tracker-tab-footer';
import ProgressDetails from './components/progress-details';
import {IProductOrderTab} from '@applications/order-tracker/config/order-tracker-new-common/types';

const ProgressTrackerTab = ({product}: IProductOrderTab) => {
    return (
        <React.Fragment>
            <Spacing top="spacing3x">
                <ProgressTrackerSection
                    title={ProductSheetProgressTracker.Title}
                />
            </Spacing>
            <ProgressDetails product={product}/>
            <ProgressTrackerTabFooter/>
        </React.Fragment>

    )
};

export default ProgressTrackerTab;
